﻿$(function ($) {
    $(function () {
        $('.menu-data ul li > a:not(:only-child)').click(function (e) {
            $(this).siblings('.menu-dropdown').toggle();
            $('.menu-dropdown').not($(this).siblings()).hide();
            e.stopPropagation();
        });
        $('html').click(function () {
            $('.menu-dropdown').hide();
        });
    });
});